import React, { useEffect, useState } from "react";
import { BOOKING_ID, CUST_ID } from "../../constants";
import dayjs, { Dayjs } from "dayjs";
import {
    DatePicker,
    LocalizationProvider,
    TimePicker,
} from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import axios from "axios";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import "./BookingSection.scss";
import { useConsentMasterQuery } from "../../Services/vehicle/Vehicle";
import { Loader } from "react-bootstrap-typeahead";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import EditCustProfile from "./EditCustProfile";
import { useNavigate } from "react-router-dom";


interface IPROPS {

    storeVehicleInfo: any;
    workshopData: any;
    setIsCheckoutClicked: any;
    workshopId: any;
    setCurrentStep: any;
    setSlotClicked: any;
    homeApiData:any
}

const CarServiceBooking: React.FC<IPROPS> = ({

    setSlotClicked,
    setCurrentStep,
    workshopId,
    setIsCheckoutClicked,
    storeVehicleInfo,
    workshopData,
    homeApiData
}) => {

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [bookServiceLoader, setBookServiceLoader] = useState(false);
    const [consents, setConsents]  = useState([])
    const [bookingData, setBookingData] = useState({})
    const [openCustProfileModal, setOpenCustProfileModal] = useState(false)
    const [homeApiDataa, setHomeApiDataa] = useState<any>({})
    
    const {data: consentMasterData} = useConsentMasterQuery({})


    const navigate = useNavigate()


    const customerData = JSON.parse(localStorage.getItem("login-type"))

    

    const [selectedServices, setSelectedServices] = useState({
        brakes: true,
        tyres: true,
        acRepairing: true,
    });

    const [consent, setConsent] = useState<any>({});

    const customerId = localStorage.getItem(CUST_ID);
    const token = localStorage.getItem("customer-token");
    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
    const now = dayjs(); // current time

    const [startHour, startMinute] =
        workshopData?.working_hours?.start_time?.split(":") || [];
    const [endHour, endMinute] =
        workshopData?.working_hours?.end_time?.split(":") || [];
    const nowPlus2Hours = now.add(2, "hour");

    const minWorkshopTime = dayjs()
        .set("hour", +startHour)
        .set("minute", +startMinute)
        .set("second", 0);
    const maxWorkshopTime = dayjs()
        .set("hour", +endHour)
        .set("minute", +endMinute)
        .set("second", 0);
    const selectedDateIsToday = selectedDate?.isSame(dayjs(), "day");

    const minTime = selectedDateIsToday
        ? dayjs.max(minWorkshopTime, nowPlus2Hours)
        : minWorkshopTime;

    const maxTime = maxWorkshopTime;


         useEffect(() => {
            if (consentMasterData) {
                setConsents(consentMasterData?.data)
    
            }
    
          },[consentMasterData])


    const shouldDisableDate = (date: Dayjs) => {
        const dayName = date.format("dddd"); // Get day name like "Sunday"
        return workshopData?.holidays?.includes(dayName);
    };

const handleBookService = async (e) => {
  e.preventDefault();

  const datePart = dayjs(selectedDate).format("YYYY-MM-DD");
  const timePart = dayjs(selectedTime).format("HH:mm:ss");
  const preferredTime = dayjs(selectedTime).format("HH:mm");

  // exclude these codes from consent_ids
  const excludedKeys = ["notify_email", "notify_phone", "notify_number", "termsCondition"];

  const selectedConsentIds = consents
    ?.filter(
      (el) =>
        el?.is_active && // only active ones
        consent[el?.input_name] && // selected (checked)
        !excludedKeys.includes(el?.input_name) // not in excluded list
    )
    .map((el) => el?.id); // collect ids

  const bookingServicePayload = {
    vehicle_id: storeVehicleInfo?.id,
    workshop_id: workshopId,
    service_type: JSON.stringify(workshopData?.services?.map((el:any) => el?.service_type_id )),
    sub_service_type: JSON.stringify(workshopData?.services?.map((el:any) => el?.sub_service_type_id )),
    customer_id: +customerId,
    service_date: `${datePart} ${timePart}`,
    preferred_time: preferredTime,

    ...(consent?.notify_email && { notify_email: 1 }),
    ...(consent?.notify_phone && { notify_phone: 1 }),
    ...(consent?.notify_number && { notify_number: 1 }),
    ...(consent?.termsCondition && { contacts_agreement: 1 }),

    consent_ids: selectedConsentIds || [],
  };

        try {
            setBookServiceLoader(true);
            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/`,
                bookingServicePayload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            if (response?.data) {
                toast.success(response?.data?.message);
                setIsCheckoutClicked(false);
                sessionStorage.clear();
                // setCurrentStep(1);
                // onClose()
                setBookingData(response?.data)

                localStorage.setItem(BOOKING_ID, response?.data?.data?.id)


const customer = homeApiDataa?.data?.customer;



             if (
  customer?.email?.trim() &&
  customer?.phone?.trim() &&
  customer?.first_name?.trim()
) {
  window.location.href = '/customer/thank-you';
} else {
  setOpenCustProfileModal(true);
}


                // setCartItems([]);
            }
        } catch (error) {
            toast.error("An error occured");
        } finally {
            setBookServiceLoader(false);
        }

    };

    console.log(homeApiDataa, "sdcdscsddsc")

     useEffect(() => {
    
            HomePageApi()
        }, [])
    
    
            const HomePageApi = async () => {
            try {
                const response = await axios.get(
                    `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/home/`,
                   
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
    
                if (response?.data) {
                    setHomeApiDataa(response?.data)
                }
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        };

    console.log(customerData, "customerData")

    const convertTo12Hour = (time24:any) => {
        if (!time24) return "";
        const [hour, minute] = time24.split(":");
        const h = parseInt(hour, 10);
        const suffix = h >= 12 ? "PM" : "AM";
        const hour12 = ((h + 11) % 12) + 1;
        return `${hour12}:${minute} ${suffix}`;
    };



    console.log(customerData?.email, "CUSTOMER_INFO")
    console.log(customerData?.first_name, "CUSTOMER_INFO")
    console.log(customerData?.phone, "CUSTOMER_INFO")


      const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    // p: 4,
  };

    return (
        <>
            <div className="booking-container">
                <h3 className="booking-container-heading">
                    Service Summary & Confirmation
                </h3>
                <div className="booking-card">
                    <div className="main-content" style={{ height: "100%" }}>
                        <div className="left-section">
                            {/* Car Section */}

                            <div className="top-grid">
                                <div className="section">
                                    <h3
                                        className="section-title"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Car
                                    </h3>
                                    <div
                                        className="car-info"
                                        style={{
                                            border: "1px solid #D7D7D7",
                                            borderRadius: "20px",
                                            padding: "10px",
                                        }}
                                    >
                                        <i className="bi bi-car-front car-icon"></i>
                                        <span
                                            style={{
                                         
                                                fontSize: "15px",
                                            }}
                                            onClick={() => {
                                                setCurrentStep(1);
                                                setSlotClicked(false);
                                                setIsCheckoutClicked(false);
                                            }}
                                        >
                                            {storeVehicleInfo?.brand_name} -{" "}
                                            {storeVehicleInfo?.model_name}
                                        </span>
                                    </div>
                                </div>

                                <div className="section">
                                    <h3
                                        className="section-title"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Workshop
                                    </h3>
                                    <div
                                        onClick={() => {
                                            setSlotClicked(false);
                                        }}
                                        className="workshop-info"
                                        style={{
                                            border: "1px solid #D7D7D7",
                                            borderRadius: "20px",
                                            padding: "10px",
                                        }}
                                    >
                                        <i className="bi bi-tools workshop-icon"></i>
                                        <span
                                            style={{
                                          
                                                fontSize: "15px",
                                            }}
                                        >
                                            {capitalizeFirstLetter(
                                                workshopData?.name
                                            )}
                                        </span>
                                    </div>
                                </div>

                                {/* Selected Services */}
                                <div className="section">
                                    <div
                                        className="section-header"
                                        style={{ marginTop: "-5px" }}
                                    >
                                        <span
                                            className="section-title"
                                            style={{
                                                marginBottom: "1px",
                                                fontSize: "18px",
                                          
                                            }}
                                        >
                                            Services offered
                                        </span>
                                        {/* <i
                                            className="bi bi-pencil edit-icon"
                                            onClick={() => {
                                                setCurrentStep(2);
                                                // setSlotClicked(false);
                                                navigate('/vehicle/service')
                                                setIsCheckoutClicked(false);
                                            }}
                                        ></i> */}
                                    </div>

                                    <div
                                        style={{
                                            border: "1px solid #D7D7D7",
                                            borderRadius: "20px",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "10px",
                                            padding: "5px",
                                            maxHeight: "250px",
                                            overflow: "scroll",
                                        }}
                                    >
                                        {workshopData?.services?.map(
                                            (services: any, index: any) => (
                                                <div className="services-list">
                                                    <div
                                                        className={`service-item ${
                                                            selectedServices.brakes
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                    >
                                                        <div className="service-icon brake-icon"></div>
                                                        <span
                                                            style={{
                                                         
                                                                fontSize:
                                                                    "15px",
                                                            }}
                                                        >
                                                            {
                                                                services?.sub_service_type
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>

                                <div>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                    >
                                        {/* Appointment Date */}
                                        <div className="section">
                                            <h3
                                                className="section-title"
                                                style={{
                                                    fontSize: "18px",
                                                    margin: "0",
                                               
                                                }}
                                            >
                                                Appointment Date
                                            </h3>
                                            <div
                                                className="date-selector"
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    borderRadius: "40px",
                                                    padding: "0",
                                                }}
                                            >
                                                {/* <i className="bi bi-calendar calendar-icon"></i> */}
                                                {/* <span className="placeholder">Select Date</span> */}
                                                <DatePicker
                                                    sx={{
                                                        width: "100%",
                                                        borderRadius: "20px",
                                                    }}
                                                    // key={index}
                                                    // label="Select Date"
                                                    value={selectedDate}
                                                    onChange={(newDate) =>
                                                        setSelectedDate(newDate)
                                                    }
                                                    minDate={dayjs()}
                                                    shouldDisableDate={
                                                        shouldDisableDate
                                                    }
                                                />
                                            </div>
                                            <p
                                           
                                                className="holiday-notice"
                                            >
                                                *Holidays :{" "}
                                                {workshopData?.holidays}
                                            </p>
                                        </div>

                                        {/* Appointment Time */}
                                        <div className="section">
                                            <h3
                                                className="section-title"
                                                style={{
                                                    fontSize: "18px",
                                                    margin: "0",
                                           
                                                }}
                                            >
                                                Appointment Time
                                            </h3>
                                            <div
                                                className="time-selector"
                                                style={{ borderRadius: "30px" }}
                                            >
                                                {/* <i className="bi bi-clock clock-icon"></i> */}
                                                {/* <span className="placeholder">Select Date</span> */}
                                                <TimePicker
                                                    sx={{
                                                        width: "100%",
                                                        borderRadius: "30px",
                                                    }}
                                                    // label="Select Time"
                                                    value={selectedTime}
                                                    onChange={(newTime) =>
                                                        setSelectedTime(newTime)
                                                    }
                                                    ampm={false}
                                                    minTime={minTime}
                                                    maxTime={maxTime}
                                                />
                                            </div>
                                            <p
                                          
                                                className="operating-hours"
                                            >
                                                *Operating Hours :{" "}
                                                {convertTo12Hour(
                                                    workshopData?.working_hours
                                                        ?.start_time
                                                )}{" "}
                                                -{" "}
                                                {convertTo12Hour(
                                                    workshopData?.working_hours
                                                        ?.end_time
                                                )}
                                            </p>
                                        </div>
                                    </LocalizationProvider>
                                </div>
                            </div>

                            {/* Communication & Consent */}

   {homeApiData?.booking_exists === 0 && (
  <div
    className="booking-consent-section"
    style={{ borderTop: "1px solid #D7D7D7", padding: "10px 0" }}
  >
    <h3 className="consent-section-title">Communication & Consent :</h3>
    <div className="consent-list-cont">
      {consents
        ?.filter((el) => el?.is_active) // ✅ Only active consents
        .map((el) => (
          <div className="consent-list" key={el.input_name}>
            <label className="consent-item">
              <input
                type="checkbox"
                checked={!!consent[el.input_name]}
                onChange={() =>
                  setConsent((prev) => ({
                    ...prev,
                    [el.input_name]: !prev[el.input_name],
                  }))
                }
              />
              <span className="checkmark"></span>
              {el?.name}{" "}
              {el?.is_mandatory && (
                <span style={{ color: "red", marginLeft :"-12px" }}>*</span> // ✅ Mandatory symbol
              )}
            </label>
          </div>
        ))}
    </div>
  </div>
)}


                             <div>
                                        <button
                                            className="book-service-btn"
                                            style={{ borderRadius: "30px"}}
                                            onClick={handleBookService}
                                        >{bookServiceLoader ? <>Booking service...<Loader /></> : "Book Service"}
                                        </button>
                                    </div>
                        </div>

                  
                    </div>
                </div>
            </div>

               {/* <Modal

                open={openCustProfileModal}
                onClose={() => {
                    setOpenCustProfileModal(false);
                    //   setCurrentStep(1)
                }}
            >
                <EditCustProfile />
              
            </Modal> */}

                 <Modal
                            open={openCustProfileModal}
                            // onClose={() => setOpenCustProfileModal(false)}
                            aria-labelledby="modal-title"
                            aria-describedby="modal-description"
                          >
                            <Box sx={{ ...style, position: "absolute" }}>
                        
                              {/* <Typography
                                id="modal-title"
                                variant="h6"
                                component="h2"
                                sx={{ mb: 2 }}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                Contact
                              </Typography> */}
            
                              <Box>
                            <EditCustProfile customerData={homeApiDataa} />
                              </Box>
                            </Box>
                          </Modal>
        </>
    );
};

export default CarServiceBooking;
